"use strict";
$(document).ready(function () {
  const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // Refresh stream setiap 5 menit

  $.ajax({
    url: "/Home/GetMonitoringCCTV",
    type: "GET",
    dataType: "json",
    success: function (response) {
      const container = $("#cctv-container-dki");
      $(".shimmer-item").remove();
      container.empty();

      $.each(response, function (index, cctv) {
        const locationName = cctv.name || `CCTV ${index + 1}`;
        // Mode single untuk thumbnail agar hemat bandwidth
        const thumbUrl = `${cctv.url}&mode=single&t=${Date.now()}`;

        const cardHtml = `
                <div class="col-6 col-md-4 col-lg-3 p-1">
                    <a href="#video-popup-placeholder"
                       class="open-cctv-video"
                       style="display:block; width:100%; aspect-ratio: 16/9; position:relative; overflow:hidden; border-radius: 4px; background:#000;"
                       data-cctv-url="${cctv.url}"
                       data-cctv-name="${locationName}">

                        <img src="${thumbUrl}" 
                             class="cctv-img"
                             data-retry="0"
                             style="width:100%; height:100%; object-fit:cover;" 
                             onerror="handleCctvError(this, '${thumbUrl}')">

                        <div style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); opacity:0.7; pointer-events:none;">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="white" style="filter: drop-shadow(0px 0px 5px rgba(0,0,0,0.5));">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </div>

                        <div style="background:linear-gradient(transparent, rgba(0,0,0,0.8)); color:white; padding:12px 8px 5px; position:absolute; bottom:0; left:0; right:0;">
                            <span style="font-size:.75rem; font-weight:500; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                ${locationName}
                            </span>
                        </div>
                    </a>
                </div>`;
        container.append(cardHtml);
      });

      initCctvPopup();
    },
  });

  function initCctvPopup() {
    $(".open-cctv-video").magnificPopup({
      type: "inline",
      midClick: true,
      mainClass: "mfp-fade",
      callbacks: {
        beforeOpen: function () {
          // Cara aman mengambil data: this.st.el (element yang memicu popup)
          const $el = this.st.el;
          $("#popupTitle").text($el.data("cctv-name"));
        },
        open: function () {
          const $el = this.st.el;
          const url = $el.data("cctv-url");

          reloadPopupStream(url);

          // Set interval refresh stream popup (anti-stuck/expired token)
          window.popupRefreshInterval = setInterval(() => {
            reloadPopupStream(url);
          }, REFRESH_INTERVAL_MS);
        },
        close: function () {
          const img = document.getElementById("popupImagePlayer");
          if (img) img.src = ""; // Stop stream
          clearInterval(window.popupRefreshInterval);
        },
      },
    });
  }

  function reloadPopupStream(url) {
    const img = document.getElementById("popupImagePlayer");
    if (img) {
      // Hilangkan mode=single agar stream menjadi video live (MJPEG)
      img.src = `${url}&t=${Date.now()}`;
    }
  }
});

// Global Function untuk Handle Error & Retry Maks 3x
function handleCctvError(img, originalUrl) {
  let retryCount = parseInt(img.getAttribute("data-retry") || 0);

  if (retryCount < 3) {
    retryCount++;
    img.setAttribute("data-retry", retryCount);
    console.warn(`Retry ke-${retryCount} untuk: ${originalUrl}`);

    setTimeout(() => {
      // Tambahkan cache buster unik tiap retry
      const separator = originalUrl.includes("?") ? "&" : "?";
      img.src = `${originalUrl}${separator}retry=${retryCount}&t=${Date.now()}`;
    }, 3000); // Jeda 3 detik agar tidak spamming
  } else {
    img.onerror = null;
    img.src = "https://via.placeholder.com/600x400?text=CCTV+Offline";
  }
}
